import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jinru",
  "use": "icon-jinru-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jinru\"><path d=\"M625.152 512l-271.36 271.36c-16.896 16.896-16.896 43.52 0 60.416 16.896 16.896 43.52 16.896 60.416 0l301.568-301.568c16.896-16.896 16.896-43.52 0-60.416L414.208 180.224c-16.896-16.896-43.52-16.896-60.416 0-16.896 16.896-16.896 43.52 0 60.416l271.36 271.36z\" p-id=\"3395\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol